import { Helmet } from 'react-helmet-async';

export const PIT = () => {
    return (
        <>
            <Helmet>
                <title>Przekaż 1% podatku PIT | Biuro rachunkowe Saldo.pl</title>
                <meta name="description" content="Wspieraj potrzebujących przekazując 1% podatku. Pomóż naszym podopiecznym - Roksanie Płoskonce i innym dzieciom przez Fundację Dzieciom 'Zdążyć z Pomocą'." />
                <meta name="keywords" content="1 procent podatku, przekazanie 1% pit, fundacja zdążyć z pomocą, krs 0000037904, rozliczenie pit, podopieczni fundacji" />
                <link rel="canonical" href="https://podatki-saldo.pl/pit" />
                <meta property="og:title" content="Przekaż 1% podatku - Pomóż potrzebującym | Saldo.pl" />
                <meta property="og:description" content="Wspieraj potrzebujących przekazując 1% podatku. Pomóż naszym podopiecznym bez ponoszenia dodatkowych kosztów." />
                <meta property="og:url" content="https://podatki-saldo.pl/pit" />
                <meta property="og:type" content="website" />
            </Helmet>
            <div className="main-pit">
                <div className={"dark-section"}>
                    <h2 className={"pit-title"}>Wesprzyj naszych podopiecznych</h2>
                    <p className={"pit-desc"}>
                        Czy wiesz, że możesz realnie pomóc potrzebującym bez ponoszenia dodatkowych kosztów? Rozliczając swój PIT, masz szansę przekazać 1.5% podatku na wybraną organizację pożytku publicznego! To naprawdę proste – wystarczy, że w odpowiedniej rubryce formularza wpiszesz numer KRS wybranej organizacji. Twój 1.5% podatku, zamiast trafić do wspólnego budżetu, wesprze konkretny, ważny cel społeczny. Nie czekaj – dołącz do grona osób, które swoją decyzją zmieniają świat na lepsze!
                    </p>
                </div>


                {/* Roksana Płoskonka */}
                <div className="pit-beneficiary-card">
                    <div className={"white-section"}>

                        <div className="beneficiary-image-container">
                            <img
                                src="/images/Roksana_Płonka.jpg"
                                alt="Roksana Płoskonka"
                                className="beneficiary-image"
                                style={{ maxWidth: '500px' , width: '100%'}}
                            />
                        </div>
                    </div>
                    <div className={"dark-section"}>
                        <div className="foundation-info">
                            <h3 className="beneficiary-name">Roksana Płoskonka</h3>
                            <h4 className="foundation-name">FUNDACJA DZIECIOM "ZDĄŻYĆ Z POMOCĄ"</h4>

                            <p className="foundation-mission">
                                Przewodnią ideą Programu ,,Zdążyć z Pomocą" jest ratowanie zagrożonego życia dzieci,
                                przywracanie im zdrowia, wspieranie ich edukacji, niesienie pomocy w trudnych warunkach materialnych.
                            </p>

                            <p className="foundation-description">
                                Fundacja Dzieciom „Zdążyć z Pomocą" jest organizacją pożytku publicznego, działającą od 1998 roku.
                                Inicjatorem Programu „Zdążyć z Pomocą" był prof. Zbigniew Religa, który pozostaje Patronem fundacji.
                                Fundację wspierają również Beata Tyszkiewicz jako Prezydent Wspólnoty „Zdążyć z Pomocą".
                            </p>

                            <p className="foundation-scope">
                                Fundacja swoją opieką otacza ponad 31 000 podopiecznych – są to dzieci z porażeniem mózgowym,
                                wadami serca, autyzmem, zespołem Downa, dystrofią mięśniową, epilepsją, chorobami nowotworowymi.
                                Przekazuje fundusze na ich leczenie, rehabilitację, zakup lekarstw, sprzętu medycznego,
                                pomocy edukacyjnych i inne specjalne potrzeby.
                            </p>
                        </div>


                    <div className="beneficiary-info">
                        <p className="beneficiary-description">
                            Jedną z podopiecznych fundacji jest Płoskonka Roksana. Nasze biuro wspiera zbiórkę funduszy
                            na pomoc i rehabilitację Roksanki. Roksana Płoskonka urodziła się 3 lipca 2003 roku
                            z Mózgowym Porażeniem Dziecięcym. Wymaga stałej opieki. W celu poprawy sprawności
                            konieczna jest rehabilitacja i masaże. Przekazywane środki pozwolą rodzicom Roksanki
                            zakupić lekarstwa i sprzęt rehabilitacyjny ułatwiający funkcjonowanie w codziennym życiu.
                        </p>
                    </div>

                    <div className="donation-details">
                        <p className="donation-target">
                            <strong>Cel szczegółowy:</strong> 9066 Płoskonka Roksana
                        </p>
                        <p className="donation-krs">
                            <strong>KRS:</strong> 0000037904
                        </p>
                    </div>
                    </div>
                </div>



                    {/* Ada Gazda */}
                    <div className="pit-beneficiary-card">
                        <div className={"white-section"}>
                            <div className="beneficiary-image-container">
                                <img
                                    src="/images/ada_gazda.png"
                                    alt="Ada Gazda"
                                    className="beneficiary-image"
                                    style={{ maxWidth: '500px' , width: '100%'}}
                                />
                            </div>
                        </div>


                        <div className={"dark-section"}>
                            <div className="foundation-info">
                                <h3 className="beneficiary-name">Ada Gazda</h3>
                                <h4 className="foundation-name">"siepomaga.pl"</h4>

                                <p className="foundation-description">
                                </p>

                            </div>


                            <div className="beneficiary-info">
                                <p className="beneficiary-description">
                                    Choroba odebrała dzieciństwo Ady!
                                    Ada przyszła na świat z poważnymi problemami zdrowotnymi, cierpi na mózgowe porażenie dziecięce i padaczkę lekooporną. W najtrudniejszym okresie ataki epilepsji pojawiały się nawet 180 razy w ciągu dnia!
                                    Córka jest objęta opieką wielu specjalistów. Na co dzień Ada jest pogodną dziewczynką, która cierpliwie znosi trudności i niedogodności spowodowane chorobą.
                                    Ada wymaga rehabilitacji ruchowej i zajęć z logopedą. Porusza się w specjalistycznym dziecięcym wózku dla niepełnosprawnych. Nie potrafi mówić, bardzo słabo widzi i jest całkowicie zależna od osób trzecich.
                                    Zwracamy się do Was z prośbą o pomoc!

                                    Rodzice
                                </p>
                            </div>

                            <div className="donation-details">
                                <p className="donation-target">
                                    <strong>Cel szczegółowy:</strong> 0060301 Ada
                                </p>
                                <p className="donation-krs">
                                    <strong>KRS:</strong> 0000396361
                                </p>
                            </div>
                        </div>
                    </div>

                     {/* Mikołaj Szwarc */}
                    <div className="pit-beneficiary-card">
                        <div className={"white-section"}>
                            <div className="beneficiary-image-container">
                                <img
                                    src="/images/mikolaj_szwarc.jpg"
                                    alt="Mikołaj Szwarc"
                                    className="beneficiary-image"
                                    style={{ maxWidth: '450px' , width: '100%'}}
                                />
                            </div>
                        </div>

                        <div className={"dark-section"}>
                            <div className="foundation-info">
                                <h3 className="beneficiary-name">Mikołaj Szwarc</h3>
                                <h4 className="foundation-name">Regionalna Fundacja Pomocy Niewidomym</h4>

                                <p className="foundation-description">
                                </p>
                            </div>

                            <div className="beneficiary-info">
                                <p className="beneficiary-description">
                                    Cześć, mam na imię Mikołaj Szwarc i mam 11 lat. Od pierwszych tygodni życia mierzę się z poważnymi problemami zdrowotnymi. Już w 7. tygodniu przeszedłem kilka operacji oczu z powodu obustronnej zaćmy, jaskry wrodzonej oraz zapalenia błony naczyniowej. Niestety, mimo leczenia, od 4. roku życia jestem osobą niewidomą.
                                    Z czasem pojawiły się kolejne trudności. Zdiagnozowano u mnie wadę budowy klatki piersiowej – tzw. klatkę lejkowatą, polegającą na wklęśnięciu mostka i żeber. Powoduje ona ból przy większym wysiłku, częstsze infekcje dróg oddechowych, a w okresie dorastania może prowadzić do problemów z sercem i płucami.
                                    Obecnie uczęszczam do szkoły w Krakowie, gdzie każdego dnia uczę się samodzielności i zdobywam umiejętności potrzebne do tego, aby w przyszłości móc jak najbardziej normalnie funkcjonować. Niezbędna jest jednak stała rehabilitacja oraz specjalistyczny sprzęt do nauki, którego koszty są bardzo wysokie.
                                    Dlatego razem z rodzicami zwracam się z prośbą o przekazanie 1,5% podatku na moje dalsze leczenie, rehabilitację oraz zakup potrzebnego sprzętu edukacyjnego. Każde wsparcie ma dla mnie ogromne znaczenie.
                                    Dziękuję z całego serca za okazaną pomoc i życzliwość.

                                    Wpłaty można kierować na konto:
                                    Regionalna Fundacja Pomocy Niewidomym
                                    ul. Dąbrowskiego 55a
                                    ING Bank Śląski: ING Bank Śląski 28 1050 1243 1000 0022 6024 6216
                                </p>
                            </div>

                            <div className="donation-details">
                                <p className="donation-target">
                                    <strong>Cel szczegółowy:</strong> MIKOŁAJ SZWARC
                                </p>
                                <p className="donation-krs">
                                    <strong>KRS:</strong> 0000018926
                                </p>
                            </div>
                        </div>
                    </div>
            </div>
        </>
    )
}
